import { AxiosPromise } from "axios";
import ApiClient from "../../../configs/axios.config";

const JobsListApi = {
  routes: {
    jobs: "jobs",
    triggerJob: "jobs/run",
  },
  methods: {
    getJobs: (): AxiosPromise<string[]> => {
      return ApiClient.get(JobsListApi.routes.jobs);
    },
    triggerJob: (jobName: string): AxiosPromise => {
      return ApiClient.get(`${JobsListApi.routes.triggerJob}/${jobName}`);
    },
  },
};

export default JobsListApi;
